/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ReportJobType {
    CLIENT_CONTACTS = 'CLIENT_CONTACTS',
    CLIENT_MT_USAGE = 'CLIENT_MT_USAGE',
    FILE_TYPES_BY_CLIENT = 'FILE_TYPES_BY_CLIENT',
    LQA_RATING_ANALYTICS = 'LQA_RATING_ANALYTICS',
}
